import * as React from 'react';
import { connect } from 'react-redux';
import { requestAPIActions } from 'loopback-react-request';
import { GlobalPrivateState, plateBuilder } from 'src/api';

export interface PricingDispatcherProps {
  dispatch: Function;
  id: string;
}

const dispatchKey = 'pricing';

class PricingDispatcherContainer extends React.Component<PricingDispatcherProps> {
  componentDidMount() {
    this.dispatchPricing();
  }

  public render() {
    return null;
  }

  private dispatchPricing() {
    this.props.dispatch(requestAPIActions.load(
      dispatchKey, {
        url: `/Pricings/${this.props.id}`
      },
      true
    ));
  }
}


export const PricingDispatcher = connect((state: GlobalPrivateState) => ({
}))(PricingDispatcherContainer);
